module.exports = __webpack_public_path__ + "img/play_circle_white_24dp.fb54e81b.svg";